import React from "react";
import { linkKind } from "./MarkdownText";

/** "PDF, 240 KB" for a file media object ("PDF" when the size is unknown). */
export function fileSummary(file) {
  const kb = Number(file.size_bytes) / 1024;
  if (!Number.isFinite(kb) || kb <= 0) return "PDF";
  return kb < 1024 ? `PDF, ${Math.max(1, Math.round(kb))} KB` : `PDF, ${(kb / 1024).toFixed(1)} MB`;
}

/**
 * The `downloads` items for one place on the site (contract v1.3
 * §3.13.1 `placement`: "resources" or "sunday_studio"), keeping only files
 * with a safe link (a page on this site or https).
 * @param {Array} items - downloads items (API or bundled)
 * @param {'resources'|'sunday_studio'} placement
 */
export function downloadsFor(items, placement) {
  return (items || []).filter(({ data }) => {
    const file = data && data.file;
    if (!file || data.placement !== placement) return false;
    const kind = linkKind(file.url);
    return kind === "internal" || kind === "external";
  });
}

/** A list of PDFs: title, file link with its size, and description. */
export default function DownloadList({ items }) {
  return (
    <ul className="resource-list">
      {items.map(({ slug, data }) => (
        <li key={slug}>
          <strong>{data.title}</strong>
          <br />
          <a href={data.file.url}>{data.file.filename || data.title}</a> ({fileSummary(data.file)})
          {data.description && <p>{data.description}</p>}
        </li>
      ))}
    </ul>
  );
}
